import React from 'react';
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import Content from "../../components/content/Content";
import DataTable from "../../components/data-table/DataTable";
import {getJuridicalPersons} from "../../services/organization";
import {getUsers} from "../../services/user";
import ActionButton from "../../components/button/ActionButton";
import messageDialogActions from '../../components/dialogs/messageDialog-acions';
import {connect} from "react-redux";
import {
    getDeletedDebts, getSpendingTypes,
    navLinks
} from "../../services/moneyFlow";
import DatePeriodField from "../../components/fields/DatePeriodField";
import moment from "moment";
import AnyField from "../../components/fields/AnyField";
import infoActions from "../../components/info/info-actions";
import {withTranslation} from "react-i18next";
import _ from "lodash";
import XLSX from "xlsx";
import SelectFromItemsField from "../../components/fields/SelectFromItemsField";
import {processMomentFieldInObject} from "../../utils/moment-utils";
import {getBusinessUnitByRole} from "../../services/user";
import MultiSelectFromItemsField from "../../components/fields/MultiSelectFromItemsField";
import DateMonthField from "../../components/fields/DateMonthField";
import {FormControl, FormControlLabel,Radio, RadioGroup} from "@material-ui/core";
import AutocompleteMultiSelectField from "../../components/fields/AutocompleteMultiSelectField";
import {loadToState} from "../../utils/helpers";

export default
@connect(state => ({
    currentParlour: state.common.currentParlour,
}),{
    showInfo: infoActions.show,
    showMessage: messageDialogActions.show,
})
@withTranslation()
class DeletedDebtListPage extends React.Component {
    state = {
        search: {
            search: null,
            date_start: null,
            date_end: null,
            month: null,
            dateType: 'period',
            businessUnitId: null,
            employeeId: null,
            spendingTypesIds: [],
            lvl: [],
            juridicalPersonIds: [],
            paymentTypes:[],
            deletedByIds: []
        },
        refreshTable: false,
        businessUnits: [],
        employees: [],
        spendingTypes: [],
        juridicalPersons:[],
        users: []
    };

    columnData = [
        { id: 'deletedAt', label: 'Deleted at', dateFormat: 'DD.MM.YYYY HH:mm:ss' },
        { id: 'deletedBy', label: 'Deleted by' },
        { id: 'amountFormat', label: 'Sum' },
        { id: 'applyAt', label: 'Debt apply', dateFormat: 'MMMM YYYY' },
        { id: 'businessUnitName', label: 'Business unit' },
        { id: 'currentAmountFormat', label: 'Current sum' },
        { id: 'reasonName', label: 'Debt name' },
        { id: 'lvl', label: 'Level' },
        { id: 'juridicalPersonName', label: 'Juridical person' },
        { id: 'comment', label: 'Comment',disableSorting:true },
        { id: 'createdAt', label: 'Created', dateFormat: 'DD.MM.YYYY HH:mm:ss' },
        { id: 'creatorName', label: 'Creator' },
    ];

    columnDataXlsx = [
        { id: 'deletedAt', label: 'Deleted at', dateFormat: 'DD.MM.YYYY HH:mm:ss' },
        { id: 'deletedBy', label: 'Deleted by' },
        { id: 'amount.val', label: 'Sum' },
        { id: 'applyAt', label: 'Debt apply', dateFormat: 'MMMM YYYY' },
        { id: 'businessUnitName', label: 'Business unit' },
        { id: 'currentAmount.val', label: 'Current sum' },
        { id: 'reasonName', label: 'Debt name' },
        { id: 'juridicalPersonName', label: 'Juridical person' },
        { id: 'comment', label: 'Comment' },
        { id: 'createdAt', label: 'Created', dateFormat: 'DD.MM.YYYY HH:mm:ss' },
        { id: 'creatorName', label: 'Creator' },
    ];

    componentDidMount() {
        getBusinessUnitByRole('ROLE_MONEYFLOW_DEBT_GET')
            .then(response => {
                if (response.success) {
                    this.setState({
                        businessUnits: response.data
                    });
                }
            });

        getSpendingTypes({showInactive: 1})
            .then(response => {
                if (response.success) {
                    this.setState({
                        spendingTypes: response.data
                    });
                }
            });
        getJuridicalPersons()
            .then(response=>{
                if(response.success){
                    this.setState({
                        juridicalPersons: response.data,
                    });

                }
            });
        loadToState(this, getUsers(), 'users')
    }

    handleChange = prop => event => {

        let value;

        if (event instanceof moment) {
            value = event;
        } else {
            value = event.target.value;
        }

        this.setState({
            search: {
                ...this.state.search,
                [prop]: value,
            }
        });
    };

    handleClickFilter = () => {
        this.setState(state => ({ refreshTable: !state.refreshTable }));
    };

    getTableData = (...params) => {
        const { search } = this.state;
        return getDeletedDebts(processMomentFieldInObject({
            ...search,
            date_start: search.date_start ? search.date_start.startOf('day') : null,
            date_end: search.date_end ? search.date_end.endOf('day') : null,
        }, ['date_start', 'date_end', 'month'],null), ...params);
    };

    handleExport = () => {
        const { t } = this.props;
        const { search, businessUnits } = this.state;
        const from = search.date_start || '';
        const to = search.date_end || '';
        const bu = search.businessUnitId ? businessUnits.find(item => item.id === search.businessUnitId).name : 'All';

        this.getTableData(1, -1)
            .then(response => {
                if (response.success) {
                    const data = [
                        //First row - headers
                        this.columnDataXlsx.map(item => t(item.label)),
                    ];

                    response.data.forEach(row => {
                        data.push(
                            this.columnDataXlsx.map(item => _.get(row, item.id))
                        );
                    });

                    const worksheet = XLSX.utils.aoa_to_sheet(data);
                    const new_workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(new_workbook, worksheet, "Deals");
                    XLSX.writeFile(new_workbook, `Debts ${bu} ${from} - ${to}.xlsx`);
                } else {
                    this.props.showMessage(response.error ? response.error.message : response.message);
                }
            });
    };

    handleCreate = () => {
        this.props.history.push(`/money-flow/debt/0`);
    };

    render() {
        const { t } = this.props;
        const {
            refreshTable,
            search,
            businessUnits,
            users,
            spendingTypes,
            juridicalPersons
        } = this.state;

        return(
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>

                    <FormControl component="fieldset" fullWidth>
                        <RadioGroup
                            value={search.dateType}
                            onChange={this.handleChange('dateType')}
                            row
                        >
                            <FormControlLabel control={<Radio/>} value="period" label="за период" />
                            <FormControlLabel control={<Radio/>} value="month" label="за месяц"/>
                        </RadioGroup>
                    </FormControl>

                    {search.dateType === 'period' ?
                        <DatePeriodField
                            valueFrom={search.date_start}
                            valueTo={search.date_end}
                            onChangeFrom={this.handleChange('date_start')}
                            onChangeTo={this.handleChange('date_end')}
                            label={t("Deleted at")}
                            required={false}
                        /> :
                        <DateMonthField
                            value={search.month}
                            onChange={this.handleChange('month')}
                            fullWidth
                        />
                    }
                    <SelectFromItemsField
                        items={businessUnits}
                        label={t("Business unit")}
                        value={search.businessUnitId}
                        onChange={this.handleChange('businessUnitId')}
                        fullWidth
                        nullable
                        nullableText="Все"
                    />
                    <AutocompleteMultiSelectField
                        options={users}
                        label={t('Deleted by')}
                        value={search.deletedByIds}
                        onChange={this.handleChange('deletedByIds')}
                        fullWidth
                        valueField={'id'}
                        textField={'username'}
                        isClearable={true}
                    />
                    <MultiSelectFromItemsField
                        items={[
                            {'id': 1, 'name': '1'},
                            {'id': 2, 'name': '2'},
                        ]}
                        emptySelectedLabel="---Не выбрано---"
                        label={t('Level')}
                        value={search.lvl}
                        onChange={this.handleChange('lvl')}
                        fullWidth
                    />
                    <AutocompleteMultiSelectField
                        label={t('Spending type')}
                        value={search.spendingTypesIds}
                        name="spendingTypesIds"
                        onChange={this.handleChange('spendingTypesIds')}
                        fullWidth
                        options={spendingTypes}
                        placeholder={t('---All---')}
                        valueField="id"
                        textField="name"
                    />
                    <AnyField
                        value={search.search}
                        onChange={this.handleChange('search')}
                        fullWidth
                        label={t("Search")}
                    />
                    <AutocompleteMultiSelectField
                        label={t('Juridical persons')}
                        value={search.juridicalPersonIds}
                        name="juridicalPersonIds"
                        onChange={this.handleChange('juridicalPersonIds')}
                        fullWidth
                        options={juridicalPersons}
                        placeholder={t('---All---')}
                        textField="shortName"
                    />
                    <MultiSelectFromItemsField
                        items={[
                            {'id': 'cash', 'name': t('pay.types.cash')},
                            {'id': 'cashless', 'name': t('pay.types.cashless')},
                        ]}
                        emptySelectedLabel="---Все типы оплаты---"
                        label={t('Payment type')}
                        value={search.paymentTypes}
                        onChange={this.handleChange('paymentTypes')}
                        fullWidth
                    />
                    <ActionButton onClick={this.handleClickFilter}>{t("Filter")}</ActionButton>
                    <ActionButton onClick={this.handleExport}>Excel</ActionButton>
                </LeftBar>
                <Content title={t("Deleted debts")}>
                    <DataTable
                        columnData={this.columnData}
                        dataFunc={this.getTableData}
                        refresh={refreshTable}
                        selector={false}
                        order="desc"
                        orderBy="createdAt"
                    />
                </Content>
            </React.Fragment>
        );
    }
}
